<dx-popup class="popup"
  [title]="languageService.LNG('Label.Change.Password')"
  [width]="350"
  [height]="500"
  [showTitle]="true"
  [dragEnabled]="true"
  [showCloseButton]="canCloseWithoutSaving"
  [(visible)]="popupVisible"
  (onShown)="onShown()"
  (onHiding)="onHiding()">

  <div *dxTemplate="let data of 'content'">
    <span><i>{{user}}</i></span>
    <div class="margin-top-medium"></div>
    <div *ngIf="enforcePasswordRules" class="password-rules">
      <ul>
        <li [class.satisfied]="rule?.satisfied" *ngFor="let rule of passwordRules">{{ rule?.text }}</li>
      </ul>
    </div>
    <div class="label">{{languageService.LNG("Label.New.Password")}}</div>
    <dx-text-box #pwd [(value)]="password" mode="password" (onInput)="validatePassword(pwd.text)"></dx-text-box>
    <div class="margin-top-medium"></div>
    <div class="label">{{languageService.LNG("Label.Verify.Password")}}</div>
    <dx-text-box #vpwd [(value)]="verifiedPassword" mode="password" (onEnterKey)="onChangePassword()" [readOnly]="!passwordIsValid" (onInput)="validateVerifiedPassword(vpwd.text)">
      <dx-validator>
        <dxi-validation-rule
          type="compare"
          [comparisonTarget]="passwordComparison"
          [message]="languageService.LNG('Label.Password.Fields.Do.Not.Match')">
        </dxi-validation-rule>
      </dx-validator>
    </dx-text-box>
    <br>
    <dx-button height="36" type="default" class="save-button" [disabled]="!passwordIsValid || !passwordIsVerified" [text]="languageService.LNG('Label.Save')" (onClick)="onChangePassword()" [useSubmitBehavior]="true">
      <div *dxTemplate="let data of 'content'">
        <dx-load-indicator class="button-indicator" [visible]="isBusy"></dx-load-indicator>
        <span *ngIf="!isBusy" class="dx-button-text">{{ languageService.LNG('Label.Save') }}</span>
      </div>
    </dx-button>
  </div>

</dx-popup>
